import { render } from "./ConfigSettings.vue?vue&type=template&id=144efc83"
import script from "./ConfigSettings.vue?vue&type=script&lang=js"
export * from "./ConfigSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__